import {Injectable, Inject} from '@angular/core';
import {Observable} from 'rxjs';
import {SoundcloudChannel, SoundCloudApiSearchResult} from "../../modele/social-media/soundcloudModels";
import {HttpHeaders, HttpClient, HttpResponse} from '@angular/common/http';
import {NGXLogger} from "ngx-logger";



export const INSTAGRAM_API_URL_USER = 'https://www.instagram.com/';
export const INSTAGRAM_API_URL_USERSEARCH = 'https://www.instagram.com/web/search/topsearch/?context=blended';
@Injectable({
  providedIn: 'root'
})
export class InstagramService {
    log_prefix = this.constructor.name + ":";

  constructor(
      private http: HttpClient,
                  @Inject(INSTAGRAM_API_URL_USER) private apiUrlUser: string,
                  @Inject(INSTAGRAM_API_URL_USERSEARCH) private apiUrlSearch: string,
                  private logger: NGXLogger

  ) {

      // https://www.instagram.com/web/search/topsearch/?context=blended&query=repr.me
      //
      //
      // https://www.instagram.com/shawnstein/?__a=1

   }

   search(query: string): Observable <any[] > {
       let lp = this.log_prefix + "search:";
       const params = `&query=${query}`;
       const queryUrl = `${this.apiUrlSearch}${params}`;
       return new Observable<any[]>((observer) => {
           // let list : VimeoChannel[] = [];
           this.http.get(queryUrl).subscribe(resp => {
               let data = resp['users'];
               observer.next(data);
           });
       });
   }




   getpostforhashtags(query: string): Observable <any[] > {
       let lp = this.log_prefix + "searchforhashtags:";
       const params = `explore/tags/${query}/?__a=1`;
       const queryUrl = `${this.apiUrlUser}${params}`;
       return new Observable<any[]>((observer) => {
           // let list : VimeoChannel[] = [];
           this.http.get(queryUrl).subscribe(resp => {
               let data = resp['graphql']['hashtag']['edge_hashtag_to_media']['edges'];
               observer.next(data);
           });
       });
   }


   userprofil(query: string): Observable <any[] > {
       let lp = this.log_prefix + "search:";

       const params = `graphql/query/?query_hash=42323d64886122307be10013ad2dcc44&variables={"id":"${query}","first":50}`;
       const queryUrl = `${this.apiUrlUser}${params}`;
       return new Observable<any[]>((observer) => {
           // let list : VimeoChannel[] = [];
           this.http.get(queryUrl).subscribe(resp => {
               let data = resp['data']['user']['edge_owner_to_timeline_media']['edges'];
               observer.next(data);
           });
       });
   }

   getVideosDetails(query: string): Observable <any[] >{
       let lp = this.log_prefix + "search:";
       const params = `p/${query}/?__a=1`;
       const queryUrl = `${this.apiUrlUser}${params}`;
       return new Observable<any[]>((observer) => {
           // let list : VimeoChannel[] = [];
           this.http.get(queryUrl).subscribe(resp => {
               let data = resp['graphql'];
               observer.next(data);
           });
       });
   }
}
